<template lang='pug'>
//- Ｃ幣是什麼？
div(:class='$style[`cc-popbox-point`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-popbox-point-title`]')
    IconCcoin(:size='46')
    span.font-bold 幣是
    span.font-bold.font-doctor-theme.no-wrap 什
    span.font-bold.font-normal-theme.no-wrap 麼
    span.font-bold ？

  div(:class='$style[`cc-point-wrap`]')
    div(:class='$style[`cc-point-wrap-block`]')
      header.font-bold(:class='$style[`cc-point-wrap-block-title`]') 什麼是C幣？
      div(:class='$style[`cc-point-wrap-block-info`]')
        span 由Cancell所發行的獎勵點數。C幣「無使用期限」，可作為商品兌換、軟體功能使用之用途。C幣僅限本人帳號使用，無法轉讓或贈與他人，請妥善保管喔。

    div(:class='$style[`cc-point-wrap-block`]')
      header.font-bold(:class='$style[`cc-point-wrap-block-title`]') 如何獲得C幣？
      div(:class='$style[`cc-point-wrap-block-info`]')
        span 每次使用「Cancell 醫抗癌」記錄副作用即可累積C幣，每日限1次領取機會。「升級為VIP會員」可享「x2倍」C幣獲取量加成。
        figure
          img(:src='`${STATIC_URL}images/news/point/step1.webp`' width='100%')

    div(:class='$style[`cc-point-wrap-block`]')
      header.font-bold(:class='$style[`cc-point-wrap-block-title`]') C幣有何用途？
      div(:class='$style[`cc-point-wrap-block-info`]')
        ul(:class='$style[`cc-point-wrap-ul`]')
          li(:class='$style[`cc-point-wrap-li`]')
            span.font-medium 1. 可扣除C幣兌換VIP訂閱
            figure
              img(:src='`${STATIC_URL}images/news/point/step2.webp`' width='100%')
          //- li(:class='$style[`cc-point-wrap-li`]')
          //-   span.font-medium 2. 「醫抗癌」使用診斷報告解說
          //-   figure
          //-     img(:src='`${STATIC_URL}images/news/point/step3.webp`' width='100%')

    div(:class='$style[`cc-content-point-controller`]')
      button.btn-extra.font-medium(
        aria-label='知道了'
        tabindex='0'
        :class='$style[`cc-point-controller-btn`]'
        @click='handleClosePopBox') 知道了

</template>

<script>
import { mapMutations } from 'vuex';
import IconCcoin from '../../icon/Ccoin';

export default {
  components: {
    IconCcoin,
  },

  // data() {
  //   return {
  //   };
  // },

  methods: {
    ...mapMutations({
      changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
    }),

    handleClosePopBox() {
      this.changePopShowTutorialStatus({
        active: false,
        include: '',
      });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  // computed: {
  //   ...mapGetters({
  //     loginDjangoId: 'user/exportUserDjangoId',
  //     loginStatus: 'user/exportLoginStatus',
  //     loginProfile: 'user/exportUserProfile',
  //   }),
  // },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popHowToGetPoint.scss';
</style>
